import httpsV2 from '../../../config/httpsV2'

export const getCategories = (lang) => {
  return httpsV2.get(`/public/categories?type=tree`)
}
